class Tabs {

  constructor(elem) {
    this.tabs = elem;
  }

  initialize() {
    const that = this;
    let tabs = this.tabs;

    let tabsLinks = tabs.children();
    let tabsBody = tabs.next();
    let tabsItem = tabsBody.children();
    let tabsContent = tabsItem.find('[data-tabs-body-item]')
    let tabsLinkMobile = tabs.closest('[data-tabs]').find('[data-tabs-link]')

    tabsLinks.on('click', function(e) {
      let el = $(this);
      let index = el.index();

      tabsLinks.removeClass('active');
      el.addClass('active');

      tabsItem.removeClass('active');
      tabsItem.eq(index).addClass('active');

      tabsContent.removeClass('active');
      tabsContent.eq(index).addClass('active');

      if (e.target.hasAttribute('data-tabs-login') || e.target.hasAttribute('data-tabs-registration')) {
        that.scrollEl(e);
      }

      e.preventDefault();
    });

    tabsLinkMobile.on('click', function(e) {
      let el = $(this);
      let parent = el.parent();

      parent.find('[data-tabs-body-item]').toggleClass('active');
      el.toggleClass('active');

      e.preventDefault();
    });

    window.addEventListener('resize', function() {
      let ww = $(window).width();
      let footerCheck = tabs.parent().parent().find('[data-tabs-footer]');

      if (ww > 991 && footerCheck.length > 0) {
        tabsItem.removeClass('active');
        tabsItem.children().removeClass('active');
        tabsLinks.removeClass('active');

        tabsLinks.eq(0).addClass('active');
        tabsItem.eq(0).children().addClass('active');
      }
    });

    // $(window).on('resize', function() {
    //   let ww = $(window).width();

    //   if (ww > 991) {
    //     tabsItem.removeClass('active');
    //     tabsItem.children().removeClass('active');
    //     tabsLinks.removeClass('active');

    //     tabsLinks.eq(0).addClass('active');
    //     tabsItem.eq(0).children().addClass('active');
    //   }
    // });
  }

  scrollEl(e) {
    $('html, body').animate({scrollTop : $('body').offset().top + 'px'}, 500);

    e.preventDefault();
  }

  initializeAbout() {
    const that = this;
    let tabs = this.tabs;
    let tabsTitles = tabs.children();
    let tabsBody = tabs.next();
    let tabsItems = tabsBody.children();
    let tabsContent = tabsItems.find('[data-tabs-body-item]')

    let subTitles = $('[data-subtabs-header]').children();


    tabsTitles.on('click', function(e) {
      e.preventDefault();

      let el = $(this);
      let index = el.index();
      let body = document.querySelectorAll('[data-tabs-body-item]')

      tabsTitles.removeClass('active');
      el.addClass('active');

      for (let i = 0; i < body.length; i++) {
        if (i === index) {
          body[i].classList.add('active')
        } else {
          body[i].classList.remove('active')
        }
      }
    });

    subTitles.on('click', function(e) {
      e.preventDefault();

      let subel = $(this);
      let indexx = subel.index();
      let titleParent = subel.parent();
      let tabsHeader = titleParent.parent();
      let curTabs = tabsHeader.parent();

      let subBody = curTabs[0].querySelectorAll('[data-subtabs-body-item]')

      subTitles.removeClass('active');
      subel.addClass('active');

      for (let i = 0; i < subBody.length; i++) {
        if (i === indexx) {
          subBody[i].classList.add('active')
        } else {
          subBody[i].classList.remove('active')
        }
      }
    })
  }
}

export {Tabs};

$(function() {
  window.Tabs = Tabs;
});

$(window).on('load', () => {
  let tabs = [];

  if ($('[data-tabs-head]').length > 0) {
    $('[data-tabs-head]').each(function(i) {
      tabs[i] = new Tabs($(this));
      tabs[i].initialize();
    });
  }

  if ($('[data-tabs-header]').length > 0) {
    $('[data-tabs-header]').each(function(i) {
      tabs[i] = new Tabs($(this));
      tabs[i].initializeAbout();
    });
  }

  if ($('[data-tab-registration]').length > 0) {
    if (window.location.pathname === '/personal/' && window.location.hash === '#registration') {
      $('[data-tab-registration]').trigger('click');
    }
  }

});
